import { motion } from 'framer-motion';
import { defaultTheme } from '../../styles/themes/defaultTheme';

const SplashScreen = () => {
    return (
        <motion.div
            // Smooth fade and slight scale in/out
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, filter: 'blur(5px)' }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
                minHeight: '100vh',
                width: '100vw',
                backgroundColor: defaultTheme.colors.primary, // Make the background your brand green
                position: 'fixed', // Keep it locked over everything
                top: 0,
                left: 0,
                zIndex: 9999
            }}
        >
            <motion.img
                initial={{ y: -15, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1, duration: 0.6 }}
                src="/RainBirdLogo.png"
                alt="RainBird Logo"
                style={{
                    width: '240px',
                    marginBottom: '2rem',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0px 8px 16px rgba(0,0,0,0.15))' // Soft shadow for depth
                }}
            />

            <motion.div
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.5 }}
                className="spinner-border text-white" // Changed to white
                role="status"
                style={{ width: '2.5rem', height: '2.5rem', borderWidth: '0.2em' }}
            >
                <span className="visually-hidden">Authenticating...</span>
            </motion.div>

            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.6 }}
                className="mt-4 fw-medium text-white" // Changed to white
                style={{ letterSpacing: '0.5px' }}
            >
                Securing your session...
            </motion.p>
        </motion.div>
    )
}

export default SplashScreen